import __isUndefined from 'lodash/isUndefined';
import __isEmpty from 'lodash/isEmpty';

const canalDiccionari = {
    'tv3': {
        codi_canal: 'tv3',
        slug: 'tv3',
        tipus: 'video'
    },
    '324': {
        codi_canal: '324',
        slug: '324',
        tipus: 'video'
    },
    '3catinfo-tv': {
        codi_canal: '324',
        slug: '3catinfo-tv',
        tipus: 'video'
    },
    'esport3': {
        codi_canal: 'esport3',
        slug: 'esport3',
        tipus: 'video'
    },
    'sx3': {
        codi_canal: 'sx3',
        slug: 'sx3',
        tipus: 'video'
    },
    'c33': {
        codi_canal: 'c33',
        slug: '33',
        imatges: '',
        logo: '33',
        titol_programa: 'El canal emet de 21.30 a 05.59',
        titol_capitol: '',
        drets_cat: 'no',
        tipus: 'video'
    },
    'tvc': {
        codi_canal: 'tvc',
        slug: 'tvc',
        tipus: 'video'
    },
    'tv3cat': {
        codi_canal: 'tv3cat',
        slug: 'tv3cat',
        tipus: 'video'
    },
    '3cat': {
        codi_canal: '3cat',
        slug: '3cat',
        tipus: 'video'
    },
    'oca1': {
        codi_canal: 'oca1',
        logo: '3catexclusiudigital',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'oca1',
        tipus: 'video'
    },
    'pucoca1': {
        codi_canal: 'pucoca1',
        logo: '3catexclusiudigital',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'pucoca1',
        tipus: 'video'
    },
    'oca2': {
        codi_canal: 'oca2',
        logo: '3catexclusiudigital',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'oca2',
        tipus: 'video'
    },
    'pucoca2': {
        codi_canal: 'pucoca2',
        logo: '3catexclusiudigital',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'pucoca2',
        tipus: 'video'
    },
    'oca3': {
        codi_canal: 'oca3',
        logo: '3catexclusiudigital',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'oca3',
        tipus: 'video'
    },
    'pucoca3': {
        codi_canal: 'pucoca3',
        logo: '',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'pucoca3',
        tipus: 'video'
    },
    'oca4': {
        codi_canal: 'oca4',
        logo: '3catexclusiudigital',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'oca4',
        tipus: 'video'
    },
    'pucoca4': {
        codi_canal: 'pucoca4',
        logo: '',
        titol_programa: "L'emissió en directe del canal exclusiu digital no està disponible en aquests moments",
        slug: 'pucoca4',
        tipus: 'video'
    },
    'cr': {
        codi_canal: 'cr',
        slug: 'catalunya-radio',
        tipus: 'audio'
    },
    'ci': {
        codi_canal: 'ci',
        slug: 'catalunya-informacio',
        tipus: 'audio'
    },
    '3catinfo-radio': {
        codi_canal: 'ci',
        slug: '3catinfo-radio',
        tipus: 'audio'
    },
    'cia': {
        codi_canal: 'cia',
        slug: 'cia',
        tipus: 'audio'
    },
    'ocr1': {
        codi_canal: 'ocr1',
        slug: 'ocr1',
        tipus: 'audio'
    },
    'cm': {
        codi_canal: 'cm',
        slug: 'catalunya-musica',
        tipus: 'audio'
    },
    'icat': {
        codi_canal: 'ic',
        slug: 'icat',
        tipus: 'audio'
    },
    'fc1': {
        codi_canal: 'fc1',
        slug: 'fc1',
        tipus: 'video'
    },
    'fc2': {
        codi_canal: 'fc2',
        slug: 'fc2',
        tipus: 'video'
    },
    'fc3': {
        codi_canal: 'fc3',
        slug: 'fc3',
        tipus: 'video'
    },
    'fc4': {
        codi_canal: 'fc4',
        slug: 'fc4',
        tipus: 'video'
    },
    'fc5': {
        codi_canal: 'fc5',
        slug: 'fc5',
        tipus: 'video'
    },
    'fc6': {
        codi_canal: 'fc6',
        slug: 'fc6',
        tipus: 'video'
    },
    'tem1': {
        codi_canal: 'tem1',
        slug: 'tem1',
        tipus: 'video'
    },
    'tem2': {
        codi_canal: 'tem2',
        slug: 'tem2',
        tipus: 'video'
    },
    'beauties': {
        codi_canal: 'beauties',
        slug: 'beauties',
        tipus: 'video'
    },
    'bdtv': {
        codi_canal: 'bondiatv',
        slug: 'bondiatv',
        imatges: [{ text: 'https://img.3cat.cat/multimedia/jpg/2/4/1637567121442.jpg', mida: '326x184' }],
        logo: 'bdtv',
        titol_programa: 'La plataforma de continguts audiovisuals impulsada per CVMC, EPRTVIB i CCMA',
        titol_capitol: '',
        tipus: 'video'
    }
};

const isCanalSlug = (canal) => {
    return Object.entries(canalDiccionari)
        .map(([key, canal]) => canal.slug)
        .includes(canal);
};

const isCodiCanal = (canal) => {
    return Object.entries(canalDiccionari)
        .map(([key, canal]) => canal.codi_canal)
        .includes(canal);
};

const getCanal = (canalId) => {
    canalId = canalId === 'e3' ? 'esport3' : canalId;
    canalId = canalId === '33' ? 'c33' : canalId;
    return Object.entries(canalDiccionari).filter(([key, canal]) => {
        return canal.codi_canal === canalId;
    })?.[0]?.[1];
};

const getTipusCanalDirecte = (directes) => {
    if (!directes || Object.keys(directes).length === 0) return null;

    const _replaceChannel = (directeId) => {
        if (directeId == null) return null;
        return directeId.replace('PUC_', '').replace('PUC', '').toLowerCase();
    };

    const id = _replaceChannel(directes[0]?.id);
    const canal = getCanal(id);
    return canal?.tipus;
};

const getDirecte = (directe) => {
    const _replaceChannel = (directeId) => {
        if (__isUndefined(directeId)) return false;
        return directeId?.replace('PUC_', '').replace('PUC', '').toLowerCase();
    };
    const canal = getCanal(_replaceChannel(directe?.id));

    if (canal)
        return {
            canal: canal.codi_canal,
            tipus: canal.tipus
        };
};

const getDirecteByTipus = (directes, tipus = 'video') => {
    if (__isEmpty(directes)) return false;
    return (
        directes.filter((directe) => getDirecte(directe)?.tipus === tipus)?.map((directe) => getDirecte(directe))[0]?.canal ||
        false
    );
};

export { canalDiccionari, isCanalSlug, isCodiCanal, getCanal, getTipusCanalDirecte, getDirecte, getDirecteByTipus };
